'use client';

import { c as _c } from "react/compiler-runtime";
import { Calendar, Popover, PopoverContent, PopoverTrigger } from '@repo/ui/components';
const CalendarDropdown = t0 => {
  const $ = _c(11);
  const {
    label,
    onChange,
    value
  } = t0;
  let t1;
  if ($[0] !== label || $[1] !== value) {
    t1 = <PopoverTrigger className="flex w-[20ch] cursor-pointer items-center gap-2 border-0 text-left outline-0 focus:ring-0 focus-visible:ring-0 focus-visible:outline-none"><div className="flex flex-col gap-1">{value?.toLocaleDateString() ? <p>{value?.toLocaleDateString()}</p> : <p>{label}</p>}</div></PopoverTrigger>;
    $[0] = label;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      chevron: "dark:fill-slate-100",
      day_button: "dark:text-slate-300",
      selected: "text-white",
      weekday: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem] text-black"
    };
    t3 = {
      before: new Date()
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onChange || $[6] !== value) {
    t4 = <PopoverContent align="start" className="dark:bg-popover w-full bg-white px-4 pb-4" side="bottom" sideOffset={13}><Calendar classNames={t2} disabled={t3} mode="single" onSelect={onChange} required={true} selected={value} showOutsideDays={false} weekStartsOn={1} /></PopoverContent>;
    $[5] = onChange;
    $[6] = value;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t4) {
    t5 = <Popover>{t1}{t4}</Popover>;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default CalendarDropdown;